import { render } from "./loader-component.vue?vue&type=template&id=095d7e24&ts=true"
import script from "./loader-component.vue?vue&type=script&lang=ts"
export * from "./loader-component.vue?vue&type=script&lang=ts"

import "./loader-component.vue?vue&type=style&index=0&id=095d7e24&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__